import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeUser } from "../../utils/userSlice";
import useRequireAuth from "../../utils/useRequireAuth";
import { ReactComponent as Dashboard } from "../../assets/images/icons/Dashb.svg";
import { ReactComponent as DashboardActive } from "../../assets/images/icons/DashboardActive.svg";
import { ReactComponent as LeftuserIcon } from "../../assets/images/icons/User_ManagementD.svg";
import { ReactComponent as UserManagementActive } from "../../assets/images/icons/UserManagementActive.svg";
import { ReactComponent as LeftManageListIcon } from "../../assets/images/icons/manage list.svg";
import { ReactComponent as ManageListActive } from "../../assets/images/icons/ManageListActive.svg";
import { ReactComponent as CategorizationD } from "../../assets/images/icons/categorization.svg";
import { ReactComponent as CategorizationActive } from "../../assets/images/icons/categActive.svg";
import { ReactComponent as Upload_COAM } from "../../assets/images/icons/UploadCOA.svg";
import { ReactComponent as COAActive } from "../../assets/images/icons/ActiveCOA.svg";
import { ReactComponent as LeftLogoutIcon } from "../../assets/images/icons/LeftLogout.svg";
import { ReactComponent as LogoutActive } from "../../assets/images/icons/LogoutActive.svg";
import { truncateString } from "../../utils/utilityFunctions/stringUtility";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import { FaRobot } from "react-icons/fa";
const SideBar = () => {
  const [activeLink, setActiveLink] = useState(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const user = useRequireAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignOut = async () => {
    const Authtoken = user.token;
    try {
      dispatch(removeUser(null));
      navigate("/dashboard");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  const [hoveredLink, setHoveredLink] = useState(null);

  const sidebarLinks = [
    { title: "Dashboard", path: "/dashboardMain", icon: <Dashboard />, iconActive: <DashboardActive />, onClick: null },
    {
      title: "User Management",
      path: "/user",
      icon: <LeftuserIcon />,
      iconActive: <UserManagementActive />,
      onClick: null,
      checkPermission: true,
    },
    // { title: "Manage Permissions", path: "/manage_permission", onClick: null, checkPermission: true },
    {
      title: "Manage List",
      path: "/managelist",
      icon: <LeftManageListIcon />,
      iconActive: <ManageListActive />,
      onClick: null,
      checkPermission: true,
    },
    {
      title: "Categorization",
      path: null,
      onClick: () => {
        const Authtoken = user.token;
        const url = `https://vgen.aizooks.com/index.html?accessin=${Authtoken}`;
        window.open(url, "_blank"); // opens in a new tab
      },
      icon: <CategorizationD />,
      iconActive: <CategorizationActive />,
    },
    {
      title: "Upload Chart of Accounts",
      path: null,
      onClick: () => {
        const Authtoken = user.token;
        const url = `https://vgen.aizooks.com/upload-coa-data.html?accessin=${Authtoken}`;
        window.open(url, "_blank"); // opens in a new tab
      },
      icon: <Upload_COAM />,
      iconActive: <COAActive />,
    },
    {
      title: "AI Chatbot",
      path: "/ai_chat_bot",
      icon: <FaRobot style={{ fontSize: "22px", color: "gray" }} />,
      iconActive: <FaRobot style={{ fontSize: "22px", color: "white" }} />,
      badge: "New",
    },
    {
      title: "Logout",
      path: null,
      icon: <LeftLogoutIcon />,
      iconActive: <COAActive />,
      iconActive: <LogoutActive />,
      onClick: handleSignOut,
    },
  ];

  const handleMenuClick = (index) => {
    setActiveLink(index); // Set active link on menu click
  };
  const getUserAccess = (value) => {
    const accessFlag = user?.permissions?.find(
      (ob) => ob?.sub_module?.toLowerCase() === value?.toLowerCase()
    )?.permission;
    return accessFlag === 1;
  };
  return (
    <div className="bg-white shadow-md rounded-md w-[100%] pt-2 h-full">
      <ul className="text-gray-600 rounded-md p-3">
        {sidebarLinks
          .filter((eachSidebar) => getUserAccess(eachSidebar.title) || !eachSidebar.checkPermission)
          .map((link, index) =>
            link.path ? (
              <li
                key={index}
                onMouseEnter={() => setHoveredLink(index)}
                onMouseLeave={() => setHoveredLink(null)}
                className={`hover:bg-cyan-900 hover:text-white hover:font-normal cursor-pointer rounded mb-1 ${
                  currentPath === link.path ? "bg-cyan-900 text-white font-normal" : ""
                }`}
              >
                <NavLink
                  exact="true"
                  to={link.path}
                  onClick={() => handleMenuClick(index)}
                  className={`block px-4 py-2 cursor-pointer ${activeLink === index ? "activeLink" : ""}`}
                >
                  <div className="flex items-center space-x-2 ">
                    {(hoveredLink === index || currentPath === link.path || activeLink === index) && link.iconActive
                      ? link.iconActive
                      : link.icon}
                    <div className="flex gap-x-2 items-start ">
                      <div>{truncateString({ str: link.title, maxLength: 25 })}</div>{" "}
                      {link.badge && (
                        <div className=" bg-red-600 text-white text-[10px] p-1 py-0 rounded font-bold shadow-sm">
                          {link.badge}
                        </div>
                      )}
                    </div>
                  </div>
                </NavLink>
              </li>
            ) : (
              <li
                key={index}
                onMouseEnter={() => setHoveredLink(index)}
                onMouseLeave={() => setHoveredLink(null)}
                onClick={() => {
                  if (link.onClick) link.onClick();
                  else handleMenuClick(index);
                }}
                className={`hover:bg-cyan-900 hover:text-white hover:font-normal cursor-pointer rounded mb-1 ${
                  activeLink === index ? "bg-cyan-900 text-white font-normal" : ""
                }`}
              >
                <div className="flex items-center px-4 py-2 space-x-2 ">
                  {(hoveredLink === index || currentPath === link.path || activeLink === index) && link.iconActive
                    ? link.iconActive
                    : link.icon}
                  <div className="flex gap-x-2 items-start ">
                    <div>{truncateString({ str: link.title, maxLength: 25 })}</div>{" "}
                    {link.badge && (
                      <div className=" bg-red-600 text-white text-[10px] p-1 py-0 rounded font-bold shadow-sm">
                        {link.badge}
                      </div>
                    )}
                  </div>
                </div>
              </li>
            )
          )}
      </ul>
    </div>
  );
};

export default SideBar;
